import type { PatientApi } from "@/Modules/Models/Api/User";
import type { Patient } from "@/Modules/Models/Domain/User";
import { AppError } from "@/Modules/App/Models/Domain/AppError";

import { useUserStore } from "@/Modules/User/Store";

import { getPatientByUser } from "@/Services/TherapyApi/Customers";

import { hasValue } from "@/Utils/Objects";

async function setUserAdditionalDataAH() {
  const userStore = useUserStore();

  if (hasValue(userStore.user)) {
    const userId = userStore.user.id;
    const patientApi = await getPatientByUser(userId);

    if (hasValue(patientApi)) {
      const patient = transformPatientApiToPatient(patientApi);

      userStore.user.patientId = patient.id;
    } else {
      //We aren't handling this situation
      throw new AppError("Patient not found");
    }
  }
}

function transformPatientApiToPatient(patientApi: PatientApi): Patient {
  const patient: Patient = {
    id: patientApi.uuid,
  };

  return patient;
}

export default setUserAdditionalDataAH;
